export const scoreTooltip = `
<div
<p style="font-size: 14px;">Alto: maior que 50% de empresas com entregas;</p>
<p style="font-size: 14px;">Médio: de 30% a 50% de empresas com entregas;</p>
<p style="font-size: 14px;">Baixo: menor que 30% de empresas com entregas.</p>
</div>
`;

export const partnerProgram = `
<p><strong>Engajado:</strong> enviou Dash nos últimos 3 meses</p>
<p><strong>Desengajado:</strong> não enviou Dash nos últimos 3 meses</p>

`;
